import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { Btn, H3, P } from '../../../../AbstractElements';
import { AddServiceAccount, addserviceRequest, serviceAccount, StbModem, Subscription, SubscriptionHistory } from '../../../../Constant';
import { useSelector } from 'react-redux';
import DataTable from 'react-data-table-component';
import { getClientUrlDataToken } from '../../../../Utils/restUtils';
import { getUserStb, getUserStbRole } from '../../../../CommonUrl';
import { StbColumns, userServiceAccountColumns } from '../../../../Data/MockTable/UserTableHeader';
import { conditionalRowStyles } from '../../../Common/Rowstyle/Rowstyle';
import { Link, useNavigate } from 'react-router-dom';

const ServiceAccountTable = (props) => {
    const propsId = props.param;
    const authState = useSelector((state) => state.auth);
    const [stbList, setStbList] = useState([]);
    const [perPage, setPerPage] = useState(10);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate()

    useEffect(() => {
        stbData(currentPage, perPage);
    }, []);
    const handlePageChange = page => {
        stbData(page, perPage,);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        stbData(page, newPerPage);
        setPerPage(newPerPage);
    };
    const stbData = async (page, size = perPage) => {
        let data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ?
            getUserStb + `?page=${page}&page_length=${size}&customer_id=${propsId}` : getUserStbRole + `?page=&page_length=&search=&customer_id=${propsId}`);
        if (data.status === true) {
            setStbList(data.data.map((e, index) => {
                return {
                    Si: index + 1,
                    StbNo: e.stb_no,
                    SerialNo: e.serial_no,
                    StbType: e.connection_type,
                    StbMake: e.device_make,
                    Provider: e.provider_name,
                    InstallDate: e.installed_date,
                    Status: e.stb_status,
                    productId: e?.product_id,
                    area: e.area_name,
                    id: e?.id,
                    stbName: e?.name || 'N/A',
                    productName: e?.product_name || "N/A",
                    next_service_due_date: e?.next_service_due_date || "N/A",
                    last_service_date: e?.last_service_date || "N/A",
                    service_end_date: e?.service_end_date || "N/A",
                    service_start_date: e?.service_start_date || "N/A"
                }
            }))
            setTotalRows(data.data.total);

        } else if (data.status >= 400 && data.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (data.status >= 500 && data.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        }
        else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };
    return (
        <Col sm="12" xl=" xl-100">
            <Card>
                <CardHeader className='d-flex justify-content-between'>
                    <H3 attrH3={{ style: { paddingLeft: '10px' } }}>{serviceAccount}</H3>
                    <div>
                        {(authState.userRole === 1 || authState.permissions.includes('store-stb')) &&
                            <Link to={`${process.env.PUBLIC_URL}/customers/add-service-account?customerId=${propsId}`} className="btn btn-primary me-2" style={{ marginLeft: '10px' }}>{AddServiceAccount}</Link>
                        }
                    </div>
                </CardHeader>
                <CardBody>
                    <div className="order-history table-responsive" style={{ marginTop: '-40px', maxHeight: '300px' }}>
                        <DataTable
                            data={stbList}
                            columns={userServiceAccountColumns}
                            conditionalRowStyles={conditionalRowStyles}
                            pagination
                            paginationTotalRows={totalRows}
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}

                        />
                    </div>
                </CardBody>
            </Card>
        </Col>
    );
};

export default ServiceAccountTable;